import React from 'react';
import Animated, { FadeIn } from 'react-native-reanimated';

import { NotFoundView } from '../../../../components';
import { QUICK_ADD_FADE_IN_DURATION } from '../../QuickAddScreen.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const QuickAddPrompt = (props: Props) => {
  const { title, description, ctaLabel, onCtaPress } = props;

  return (
    <Animated.View entering={FadeIn.duration(QUICK_ADD_FADE_IN_DURATION)}>
      <NotFoundView
        title={title}
        description={description}
        btnLabel={ctaLabel}
        onBtnPress={onCtaPress}
        withoutFooter
      />
    </Animated.View>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title: string;
  description: string;
  ctaLabel: string;
  onCtaPress: () => void;
};
